import { render, staticRenderFns } from "./SanteSeniors.vue?vue&type=template&id=e5f36dac&"
import script from "./SanteSeniors.vue?vue&type=script&lang=js&"
export * from "./SanteSeniors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports